<rt-icon-button
  #tableConfigDropdownTrigger="rtOverlayOrigin"
  (click)="toggleTableConfigDropdown()"
  variant="secondary"
  iconName="table-edit"
  shape="square"
  rt-overlay-origin
>
  <rt-icon name="table-edit"></rt-icon>
</rt-icon-button>

<ng-template
  #tableConfigDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [open]="dropdownOpened"
  [origin]="tableConfigDropdownTrigger"
  (backdropClick)="toggleTableConfigDropdown()"
>
  <rt-dropdown>
    <rt-dropdown-header>
      {{ 'rtu.search.table.adjust_columns' | translate }}
    </rt-dropdown-header>
    <div
      #dataTableOptionsDropdown
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
      [style.maxHeight]="'300px'"
      class="has-dark-scroll-y drag-boundary"
    >
      <rt-dropdown-item
        *ngFor="let column of tableColumns; let last = last; trackBy: trackByColumnId"
        (click)="toggleColumnVisibility(column); $event.preventDefault()"
        [hasHoverEffect]="hoverEffects !== false"
        [noDivider]="last"
        cdkDrag
        cdkDropListLockAxis="y"
        cdkDragBoundary=".drag-boundary"
      >
        <rt-checkbox
          prefix
          [style.pointerEvents]="'none'"
          [disabled]="!column.options.removable"
          [checked]="column.visible"
        ></rt-checkbox>
        <div layout layout-align-items-center>
          <div>{{ column.label }}</div>
          <rt-badge
            *ngIf="column.isNew"
            color="primary"
            [text]="'app.common.new' | translate"
            margin-left-small-x
          >
          </rt-badge>
        </div>
        <rt-icon suffix class="drag-icon" size="small" name="drag-vertical"></rt-icon>
      </rt-dropdown-item>
    </div>

    <rt-divider></rt-divider>
    <rt-dropdown-item
      *ngIf="!hideAutoFit"
      (click)="tableAutoFitChange.emit(!tableAutoFit); $event.preventDefault()"
    >
      <rt-checkbox prefix [style.pointerEvents]="'none'" [checked]="tableAutoFit"></rt-checkbox>
      {{
        (tableAutoFit ? 'rtu.search.table.auto_fit_enabled' : 'rtu.search.table.auto_fit_disabled')
          | translate
      }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
